// -------------------------- drawer open filter ----------------------------------------

document.addEventListener('DOMContentLoaded', function () {
  function openFilter(section) {
    var panel = section.querySelector('.collection-toolbar');
    var overlay = section.querySelector('.m-filter-overlay');
    if (!panel) return;

    panel.classList.add('is-open');
    if (overlay) overlay.classList.add('is-visible');
    document.body.classList.add('no-scroll');
  }

  function closeFilter(section) {
    var panel = section.querySelector('.collection-toolbar');
    var overlay = section.querySelector('.m-filter-overlay');
    if (!panel) return;

    panel.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-visible');
    document.body.classList.remove('no-scroll');
  }

  // 🔹 CLICK: open / close when mobile filter button is clicked
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.m-mob-filter');
    if (btn) {
      var section = btn.closest('[data-section-type="collection-filter-poc"]');
      if (!section) return;

      var panel = section.querySelector('.collection-toolbar');
      if (!panel) return;

      if (panel.classList.contains('is-open')) {
        closeFilter(section);
      } else {
        openFilter(section);
      }
      return;
    }

    // 🔹 CLICK: close when overlay clicked
    var overlay = e.target.closest('.m-filter-overlay');
    if (overlay) {
      var section = overlay.closest('[data-section-type="collection-filter-poc"]');
      if (!section) return;
      closeFilter(section);
    }
  });

  // 🔹 ESC key: close any open filter
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var openSection = document.querySelector(
        '[data-section-type="collection-filter-poc"] .collection-toolbar.is-open'
      );
      if (openSection) {
        var section = openSection.closest('[data-section-type="collection-filter-poc"]');
        if (section) closeFilter(section);
      }
    }
  });
});

// ----------------------------------------------------------------- filter expand -------------------------------------------

document.addEventListener('DOMContentLoaded', function() {
  // Accordion
  document.querySelectorAll('[data-accordion-button]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', !expanded);
      var panel = btn.nextElementSibling;
      if (!panel) return;
      panel.style.display = expanded ? 'none' : 'block';
    });
  });

  // Price sliders
  document.querySelectorAll('[data-price-filter-wrapper]').forEach(function(wrapper) {
    var minRange = wrapper.querySelector('[data-price-min]');
    var maxRange = wrapper.querySelector('[data-price-max]');
    var minInput = wrapper.querySelector('[data-price-min-input]');
    var maxInput = wrapper.querySelector('[data-price-max-input]');
    var minText  = wrapper.querySelector('[data-price-min-text]');
    var maxText  = wrapper.querySelector('[data-price-max-text]');

    if (!minRange || !maxRange) return;

    function sync() {
      var minVal = parseFloat(minRange.value);
      var maxVal = parseFloat(maxRange.value);

      if (minVal > maxVal) {
        var temp = minVal;
        minVal = maxVal;
        maxVal = temp;
      }

      minRange.value = minVal;
      maxRange.value = maxVal;

      if (minInput) minInput.value = minVal;
      if (maxInput) maxInput.value = maxVal;
      if (minText)  minText.textContent = minVal;
      if (maxText)  maxText.textContent = maxVal;
    }

    minRange.addEventListener('input', sync);
    maxRange.addEventListener('input', sync);
    sync();
  });
});


// ------------------------------------- show 8 filter vlaue ------------------------------------------------
document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('click', function(event) {
    const button = event.target.closest('[data-show-all]');
    if (!button) return;

    const filterId = button.getAttribute('data-show-all');
    const section = button.closest('[data-section-type="collection-filter-poc"]');
    const scope = section || document;
    const hiddenItems = scope.querySelectorAll(`[data-filter-item="${filterId}"]`);
    const showAllText = button.querySelector('.show-all-text');
    const showLessText = button.querySelector('.show-less-text');

    hiddenItems.forEach(item => {
      item.classList.toggle('filter-item--visible');

      // If items become visible, remove the hidden class
      if (item.classList.contains('filter-item--visible')) {
        item.style.display = 'list-item';
      } else {
        item.style.display = 'none';
      }
    });

    // Toggle button text
    if (showAllText && showLessText) {
      if (showAllText.style.display === 'none') {
        showAllText.style.display = 'inline';
        showLessText.style.display = 'none';
      } else {
        showAllText.style.display = 'none';
        showLessText.style.display = 'inline';
      }
    }
  });
});


// --------------------------------------- filter without reload -------------------

document.addEventListener('DOMContentLoaded', function () {
  const sectionSelector = '[data-section-type="collection-filter-poc"]';

  function initCollectionSection(section) {
    if (!section) return;

    const sectionId = section.getAttribute('data-section-id');
    var isRequestInFlight = false;

    function isDrawerOpen(targetSection) {
      var panel = targetSection.querySelector('.collection-toolbar');
      return !!(panel && panel.classList.contains('is-open'));
    }

    function setDrawerState(targetSection, shouldOpen) {
      var panel = targetSection.querySelector('.collection-toolbar');
      var overlay = targetSection.querySelector('.m-filter-overlay');

      if (!panel) return;

      panel.classList.toggle('is-open', shouldOpen);
      if (overlay) overlay.classList.toggle('is-visible', shouldOpen);
      document.body.classList.toggle('no-scroll', shouldOpen);
    }

    // ---------- helper: load this section via AJAX ----------
    function renderSectionFromUrl(url, options) {
      options = options || {};
      if (isRequestInFlight) return Promise.resolve();

      const urlObj = new URL(url, window.location.origin);
      urlObj.searchParams.set('section_id', sectionId);
      const isMobileViewport = window.matchMedia('(max-width: 749px)').matches;
      const drawerWasOpen = isMobileViewport && isDrawerOpen(section);
      const closeMobileDrawer = !!options.closeMobileDrawer;
      const keepDrawerOpen = drawerWasOpen && !closeMobileDrawer;

      if (closeMobileDrawer && drawerWasOpen) {
        setDrawerState(section, false);
      }

      isRequestInFlight = true;
      if (!keepDrawerOpen) {
        section.classList.add('is-loading');
      }

      return fetch(urlObj.toString(), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newSection = doc.querySelector(sectionSelector);

          if (!newSection) {
            console.warn('AJAX collection: new section not found in response');
            section.classList.remove('is-loading');
            if (!keepDrawerOpen) {
              document.body.classList.remove('no-scroll');
            }
            isRequestInFlight = false;
            return;
          }

          section.parentNode.replaceChild(newSection, section);
          if (keepDrawerOpen) {
            setDrawerState(newSection, true);
          } else {
            document.body.classList.remove('no-scroll');
          }
          isRequestInFlight = false;
          initCollectionSection(newSection); // re-bind listeners on new DOM
        })
        .catch(function (err) {
          console.error('AJAX collection error:', err);
          section.classList.remove('is-loading');
          if (!keepDrawerOpen) {
            document.body.classList.remove('no-scroll');
          }
          isRequestInFlight = false;
        });
    }

    // ---------- FILTERS (auto apply on change) ----------
    const filtersForm = section.querySelector('#CollectionFiltersForm');
    if (filtersForm) {
      var autoApplyTimer;

      function applyFiltersFromForm() {
        const formData = new FormData(filtersForm);
        const searchParams = new URLSearchParams(formData);

        const url =
          window.location.pathname +
          (searchParams.toString() ? '?' + searchParams.toString() : '');

        renderSectionFromUrl(url, { closeMobileDrawer: true }).then(function () {
          window.history.pushState({}, '', url);
        });
      }

      filtersForm.addEventListener('submit', function (event) {
        event.preventDefault();
        applyFiltersFromForm();
      });

      filtersForm.addEventListener('change', function (event) {
        const target = event.target;
        if (!target) return;

        if (
          target.matches('input[type="checkbox"]') ||
          target.matches('input[type="range"]') ||
          target.matches('select')
        ) {
          clearTimeout(autoApplyTimer);
          autoApplyTimer = setTimeout(function () {
            applyFiltersFromForm();
          }, 120);
        }
      });
    }

    // ---------- SORTING (desktop + mobile) – NO RELOAD ----------
    // We hook on <select> change directly and stop everything else
    const sortSelects = section.querySelectorAll('#SortBySelect, #SortBySelectMobile');

    sortSelects.forEach(function (select) {
      select.addEventListener('change', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation(); // stop theme's default handlers

        const form = select.form;
        if (!form) return;

        const formData = new FormData(form);
        const searchParams = new URLSearchParams(formData);

        const url =
          window.location.pathname +
          (searchParams.toString() ? '?' + searchParams.toString() : '');

        renderSectionFromUrl(url).then(function () {
          window.history.pushState({}, '', url);
        });
      });
    });

    // (optional) If you kept form.submit handlers from older code, you can remove them now.
    // We don't rely on submit for sorting anymore.

    // ---------- Back / forward buttons support ----------
    window.onpopstate = function () {
      renderSectionFromUrl(window.location.href);
    };
  }

  const initialSection = document.querySelector(sectionSelector);
  if (initialSection) {
    initCollectionSection(initialSection);
  }
});
